export default function appReducer(state, action) {
  const type = action.type.split("_")[0];
  const model = action.type.split("_")[1];
  switch (type) {
    case "request": {
      state[`res${model}`] = [];
      state[`is${model}`] = true;
      return { ...state };
    }
    case "error": {
      state[action.type] = action.error;
      state[`err_${model}`] = false;
      return { ...state };
    }
    case "response": {
      state[`res${model}`] = action?.response?.data;
      state[`is${model}`] = false;
      return { ...state };
    }
    case "setdata": {
      state[`res${model}`] = action.response;
      return { ...state };
    }
    case "collect": {
      return { ...state, collect: action.response };
    }
    case "login": {
      return {
        ...state,
        // islogin: !!JSON.parse(localStorage.getItem("auth")),
        // _auth: JSON.parse(localStorage.getItem("auth")),
        lang: "mn",
        errorMsg: "",
        islogin: action.response,
        _auth: action.response
          ? JSON.parse(localStorage.getItem("auth"))
          : undefined,
      };
    }
    case "auth": {
      return {
        ...state,
        _auth: action.response,
      };
    }
    default:
      return state;
  }
}
